import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { CTAButton } from './CTAButton';
const faqs = [{
  question: '¿Qué recibo al comprar?',
  answer: 'Recibís acceso inmediato a los 5 Tomos en formato Word y PDF, más los 4 bonos incluidos en tu pack. Todo llega a tu correo en menos de 5 minutos.'
}, {
  question: '¿Cuándo me llega?',
  answer: 'El acceso es inmediato. En menos de 5 minutos recibís el correo con todos los materiales listos para descargar.'
}, {
  question: '¿Es físico o digital?',
  answer: 'Es 100% digital. Podés descargarlo desde cualquier dispositivo, en cualquier momento y desde cualquier lugar.'
}, {
  question: '¿Necesito ser docente recibido?',
  answer: 'No. El material está pensado para cualquier persona que esté frente a un aula de secundaria, con o sin título en curso.'
}, {
  question: '¿Tengo acceso para siempre?',
  answer: 'Sí. El acceso es de por vida. Una sola compra y el material es tuyo para siempre, incluyendo futuras actualizaciones.'
}, {
  question: '¿Qué pasa si no me llega el acceso?',
  answer: 'Escribinos de inmediato a nuestro soporte y lo resolvemos en menos de 24 horas. Nadie se queda sin su material.'
}, {
  question: '¿Es una compra segura?',
  answer: 'Sí. El pago se procesa a través de Mercado Pago, la plataforma más segura de Latinoamérica. Tus datos están 100% protegidos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-darker px-4" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <div className="text-center mb-12" data-id="element-39">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4 uppercase" data-id="element-40">
            Resolvé tus dudas
          </h2>
        </div>

        <div className="space-y-3 mb-12" data-id="element-41">
          {faqs.map((faq, index) => <div key={index} className="bg-brand-card rounded-lg border border-white/5 overflow-hidden" data-id="element-42">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-43">
                <span className="font-heading font-bold text-white text-base pr-8 uppercase" data-id="element-44">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent flex-shrink-0" data-id="element-45" /> : <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-46" />}
              </button>

              {openIndex === index && <div className="px-5 pb-4 text-gray-400 text-sm leading-relaxed border-t border-white/5 pt-3 font-body" data-id="element-47">
                  {faq.answer}
                </div>}
            </div>)}
        </div>

        <div className="text-center" data-id="element-48">
          <CTAButton text="👉 Quiero acceder ahora sin riesgo" data-id="element-49" />
        </div>
      </div>
    </section>;
}